export default __webpack_public_path__ + "static/media/Anirudh Ravichander.795c0f9e.jpg";